import { UserAuthority } from '@/constants';
import statisticsService from '@/services/statisticsService';
import { useModel, useRequest } from '@umijs/max';

export default (): {
  platformOverview: API.Service.PlatformOverview | undefined;
  platformOverviewLoading: boolean;
  refreshPlatformOverview: () => void;
} => {
  const { ready } = useModel('@@initialState', (model) => ({
    ready:
      !!model.initialState?.currentUser &&
      model.initialState?.currentUser?.authority ===
        UserAuthority.ADMINISTRATOR,
    //currentUser: model.initialState?.currentUser,
  }));

  const {
    data: platformOverview,
    loading: platformOverviewLoading,
    refresh: refreshPlatformOverview,
  } = useRequest<API.Service.PlatformOverview>(
    statisticsService.platformStatistics,
    {
      ready,
    },
  );

  return {
    platformOverview,
    platformOverviewLoading,
    refreshPlatformOverview,
  };
};
